/* R59 (Oct 25 2026): Shopify's theme JSON stops at 250 variants per product. Kids Kids Pizza (416) and
   Kids Peep Peep Special (480) carry every Toast choice combination as a variant, so anything past the
   250th combo looked "not available". This loads the full list from the Storefront API (no token
   needed) right after the page loads and writes it back into the dish's JSON, before the guest taps. */
(function () {
  'use strict';
  var Q = 'query($h:String!,$a:String){product(handle:$h){options{name} variants(first:250,after:$a){pageInfo{hasNextPage endCursor} nodes{id title availableForSale price{amount} selectedOptions{name value}}}}}';
  function gql(h, a) {
    return fetch('/api/2025-07/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: Q, variables: { h: h, a: a || null } }) })
      .then(function (r) { return r.json(); });
  }
  function all(h) {
    var out = [], names = null;
    function page(a) {
      return gql(h, a).then(function (j) {
        var p = j && j.data && j.data.product; if (!p) throw new Error('none');
        names = names || p.options.map(function (o) { return o.name; });
        out = out.concat(p.variants.nodes);
        return p.variants.pageInfo.hasNextPage ? page(p.variants.pageInfo.endCursor) : { names: names, vs: out };
      });
    }
    return page(null);
  }
  function fill(s) {
    var p; try { p = JSON.parse(s.textContent); } catch (e) { return; }
    if (!p || !p.handle || !p.variants || p.variants.length < 250) return;
    all(p.handle).then(function (r) {
      if (r.vs.length <= p.variants.length) return;
      p.variants = r.vs.map(function (v) {
        var so = {}; v.selectedOptions.forEach(function (o) { so[o.name] = o.value; });
        return { id: +String(v.id).split('/').pop(), title: v.title, price: Math.round(parseFloat(v.price.amount) * 100), available: !!v.availableForSale, opts: r.names.map(function (n) { return so[n]; }) };
      });
      s.textContent = JSON.stringify(p);
    }).catch(function () {});
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('script[data-cgm-product]'), fill); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
